// extracted by mini-css-extract-plugin
module.exports = {"carouselSection":"BlogCarousel_carouselSection__nXqeI","shimmer":"BlogCarousel_shimmer__y6Nxt"};